import { createFileRoute } from '@tanstack/react-router'
import { CreateTicketForm } from '@/features/ticket-create/CreateTicketForm'
import { useViewAs } from '@/lib/viewAs'

function NewTicket() {
  // The lens is read-only: a ticket raised from it would be the admin's, not the user's.
  if (useViewAs()) {
    return <div className="p-6 text-sm text-muted-foreground">You can&apos;t raise a ticket while viewing as another user.</div>
  }
  return <CreateTicketForm />
}

export const Route = createFileRoute('/tickets/new')({ component: NewTicket })
